import { Component, Vue } from 'vue-property-decorator'
import Header from './shared/Header.vue'
import Breadcrumb from './components/Breadcrumb.vue'

@Component({
    components: {
        Header,
        Breadcrumb
    },
    computed: {
        isHomePage(): boolean {
            return this.$route.path === '/'
        }
    }
})
export default class AppComponent extends Vue {}
